module.exports = __webpack_public_path__ + "static/assets/99549dc880fed3e1108beeff12d4f2f8.svg";